import CopyrightView from './Copyright.View';

const Copyright = () => <CopyrightView />;

export default Copyright;
